import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function AddCardDialog({ open, onOpenChange, onAdded }) {
    const [name, setName] = useState("");
    const [number, setNumber] = useState("");
    const [exp, setExp] = useState("");
    const [cvc, setCvc] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const submit = async () => {
        if (!name || !number || !exp) {
            toast.error("Fill all fields");
            return;
        }
        const [mm, yy] = exp.split("/");
        setSubmitting(true);
        try {
            await api.post("/payments/cards", {
                holder_name: name,
                card_number: number.replace(/\s+/g, ""),
                exp_month: parseInt(mm, 10),
                exp_year: parseInt(yy?.length === 2 ? `20${yy}` : yy, 10),
            });
            toast.success("Card added");
            setName("");
            setNumber("");
            setExp("");
            setCvc("");
            onOpenChange(false);
            onAdded?.();
        } catch (error) {
            console.warn("[payment] add card failed", error?.message);
            toast.error(error?.response?.data?.detail || "Could not add card");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Add payment card</DialogTitle>
                </DialogHeader>
                <div className="space-y-3">
                    <div>
                        <Label>Cardholder name</Label>
                        <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Alex Morgan" data-testid="add-card-name" />
                    </div>
                    <div>
                        <Label>Card number</Label>
                        <Input value={number} onChange={(e) => setNumber(e.target.value)} placeholder="4242 4242 4242 4242" data-testid="add-card-number" />
                    </div>
                    <div className="grid grid-cols-2 gap-3">
                        <div>
                            <Label>Exp (MM/YY)</Label>
                            <Input value={exp} onChange={(e) => setExp(e.target.value)} placeholder="12/30" data-testid="add-card-exp" />
                        </div>
                        <div>
                            <Label>CVC (mocked)</Label>
                            <Input value={cvc} onChange={(e) => setCvc(e.target.value)} placeholder="123" data-testid="add-card-cvc" />
                        </div>
                    </div>
                </div>
                <div className="flex justify-end gap-2 mt-4">
                    <Button variant="outline" onClick={() => onOpenChange(false)}>
                        Cancel
                    </Button>
                    <Button onClick={submit} disabled={submitting} data-testid="add-card-save">
                        {submitting && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}
                        Save card
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}
